var _circle, _path, _path2, _circle2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 220 220",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.88,
    cy: 41.25,
    r: 32.086,
    fill: "#7b83eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m114.59 48.125h-29.054l0.144 0.639 0.014 0.055 0.144 0.592c4.362 16.534 21.203 26.834 37.909 23.182v-15.304c-0.015-5.021-4.142-9.149-9.164-9.164z",
    fillOpacity: 0.098039,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m107.71 55h-19.828c5.302 11.18 16.618 18.336 28.992 18.336v-9.165c-0.015-5.022-4.143-9.149-9.164-9.164z",
    fillOpacity: 0.2,
    fillRule: "nonzero"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.06,
    cy: 51.563,
    r: 24.063,
    fill: "#5059c9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-170,-90)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m379.69 172.5h-54.045c-2.41 0-4.393 1.983-4.393 4.393v55.756c-0.31 16.57 11.12 31.225 27.266 34.96 2.325 0.488 4.693 0.733 7.068 0.733 18.872 0 34.404-15.521 34.416-34.393v-51.137c0-5.657-4.655-10.312-10.312-10.312z",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.88 182.81v65.343c0 30.153-24.812 54.965-54.966 54.965-19.618 0-37.804-10.503-47.609-27.496-1.323-2.199-2.472-4.498-3.438-6.875-0.9-2.242-1.657-4.538-2.268-6.875-1.134-4.496-1.711-9.114-1.719-13.75v-65.313-0.013c0-5.65 4.649-10.299 10.299-10.299h89.402c5.65 0 10.299 4.649 10.299 10.299z",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.71 145h-19.828c5.302 11.18 16.618 18.336 28.992 18.336v-9.165c-0.015-5.022-4.143-9.149-9.164-9.164z",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.75 172.5v87.106c0 4.255-2.992 7.966-7.15 8.869-0.647 0.192-1.319 0.285-1.994 0.275h-48.744c-0.9-2.242-1.657-4.538-2.268-6.875-1.134-4.496-1.711-9.114-1.719-13.75v-65.313-0.013c0-5.65 4.649-10.299 10.299-10.299z",
    fillOpacity: 0.098039
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.88 172.5v93.981c0.01 0.675-0.083 1.347-0.275 1.994-0.903 4.158-4.614 7.15-8.869 7.15h-38.431c-1.323-2.199-2.472-4.498-3.437-6.875-0.901-2.242-1.658-4.538-2.269-6.875-1.134-4.496-1.711-9.114-1.719-13.75v-65.313-0.013c0-5.65 4.649-10.299 10.299-10.299zv80.231c-0.023 5.008-4.136 9.121-9.144 9.144h-44.137c-1.134-4.496-1.711-9.114-1.719-13.75v-65.313-0.013c0-5.65 4.649-10.299 10.299-10.299zm-44.688 0h-0.013c-5.65 0-10.299 4.649-10.299 10.299v65.326c8e-3 4.636 0.585 9.254 1.719 13.75h37.262c5.008-0.023 9.121-4.136 9.144-9.144v-80.231z",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.16 145h91.665c5.027 0 9.164 4.137 9.164 9.164v91.665c0 5.027-4.137 9.164-9.164 9.164h-91.665c-5.027 0-9.164-4.137-9.164-9.164v-91.665c0-5.027 4.137-9.164 9.164-9.164z",
    fill: "#4b53bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.36 179.2h-20.55v55.138h-13.502v-55.138h-20.667v-13.544h54.719z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h220v220h-220z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.eb8acdcbd1405f742f9bb72103b3af9b.svg";
export { ForwardRef as ReactComponent };